<template>
  <div class="graph" ref="container">
    <div ref="graph"></div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import c3 from 'c3'
  import Visibility from 'visibilityjs'
  import api from '@/api'

  export default {
    data: () => ({}),
    props: {
      endpoint: String,
      period: String,
      height: null,
    },
    methods: {
      showGraph (data) {
        const dataGraph = data || this.dataGraph
        this.chart = c3.generate({
          color: {
            pattern: [
              '#08588f', // $blue
              '#00a0e3', // $cyan
              '#bf3030', // $red
              '#fd7e14', // $orange
              '#7db22d', // $green
              '#dbc942', // $yellow
              '#e83e8c', // $pink
              '#6610f2', // $indigo
              '#6f42c1', // $purple
              '#20c997', // $teal
            ],
          },
          bindto: this.$refs.graph,
          size: {
            height: this.height || 0,
          },
          data: {
            x: 'x',
            xFormat: '%Y-%m-%dT%H:%M:%S',
            columns: [
              dataGraph.values,
              dataGraph.sales,
              dataGraph.revenue,
              dataGraph.before_sales,
              dataGraph.before_revenue,
            ],
            names: {
              sales: 'Кол-во (dex)',
              revenue: 'Сумма (dex)',
              before_sales: 'Кол-во (mdb)',
              before_revenue: 'Сумма (mdb)',
            },
            axes: {
              revenue: 'y2',
              before_revenue: 'y2',
            },
            type: 'bar',
            groups: [
              ['sales', 'before_sales'],
              ['revenue', 'before_revenue'],
            ],
            order: (t1, t2) => {
              return false
            },
          },
          grid: {
            y: {
              show: true,
            },
          },
          axis: {
            x: {
              type: 'timeseries',
              tick: {
                fit: true,
                format: dataGraph.formatPrint,
              },
            },
            y: {
              label: {
                text: 'Кол-во продаж, шт.',
                position: 'outer-middle',
              },
              padding: {top: 0, bottom: 0},
            },
            y2: {
              label: {
                text: 'Выручка, руб.',
                position: 'outer-middle',
              },
              show: true,
              padding: {top: 0, bottom: 0},
            },
          },
          bar: {
            width: {
              ratio: 1 / 1.61803398875,
            },
          },
        })
        Visibility.onVisible(() => {
          this.chart.flush()
        })
      },
    },
    asyncComputed: {
      dataGraph () {
        return api.get(this.endpoint, {
          params: {
            period: this.period,
          },
        }).then(({data}) => {
          const $container = $(this.$refs.container)
          $container.height($container.height())
          this.chart && this.chart.destroy()
          this.showGraph(data.data)
          $container.css('height', '')

          return data.data
        })
      },
    },
    watch: {
      dataGraph (data) {
        this.$emit('update:data', data)
      },
    },
    beforeDestroy () {
      this.chart && this.chart.destroy()
    },
  }
</script>

<style lang="scss">
  @import "~c3/c3.css";
  .graph {
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/graph.vue